export default "__VITE_ASSET__BBVotTbm__"